import { TGetFundingRequirementsResponse } from '../../../../api/lending/edge';
import { checkRequirement } from '../../helpers/requirements';

/**
 * Whether the ID check funding requirement is resolved, based on the
 * requirement status rather than the item status — the two disagree when a
 * check is re-triggered (e.g. error code 256).
 */
export const isIdCheckFundingRequirementComplete = (
  fundingRequirements: TGetFundingRequirementsResponse['data'] | null,
): boolean => {
  if (!fundingRequirements) return false;

  return (
    checkRequirement(fundingRequirements, 'onfido_check', 'completeness') ||
    checkRequirement(
      fundingRequirements,
      'onfido_video_check',
      'completeness',
    ) ||
    checkRequirement(fundingRequirements, 'idverse_check', 'completeness')
  );
};
